import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { knowledgeBaseApi } from 'api/knowledgeBase';
import { Box, BoxSection } from 'components/_new/Box';
import { Button } from 'components/_new/Button';
import { useAuth } from 'contexts/authContext';
import { usePanel } from 'contexts/panelContext';
import { BlogArticlesSkeleton } from './skeletons/BlogArticlesSkeleton';

export const BlogArticles = () => {
	const { t } = useTranslation();

	const { currentUser } = useAuth();
	const { currentApplicationData } = usePanel();

	const { data, isLoading } = useQuery(
		[
			'KNOWLEDGE_BASE_BLOG_ARTICLES',
			{
				applicationId: Number(currentApplicationData?.id),
				languageCode: currentUser?.language,
				isProfessionalViewEnabled: currentUser?.isProfessionalViewEnabled,
			},
		],
		() => knowledgeBaseApi.application.getBlogArticles(Number(currentApplicationData?.id)),
		{
			enabled: true,
		}
	);

	if (isLoading) {
		return <BlogArticlesSkeleton />;
	}

	return (
		<div className="flex flex-row gap-2 justify-content-start align-content-stretch overflow-x-auto">
			{!data?.length ? (
				<div className="text-muted text-center">{t('misc.empty')}</div>
			) : (
				data?.map(({ id, title, info }) => {
					return (
						<Link
							to={info?.link || '#'}
							target="_blank"
							key={id}
							className="flex article-tile"
							tabIndex={-1}
						>
							<Box
								className="w-full"
								variant="white-bordered"
								hoverable
								img={info?.imageUrl || 'default'}
							>
								<BoxSection className="flex-1">
									<span className="strong">{title}</span>
								</BoxSection>
								<BoxSection>
									<Button
										label={t('actions.open')}
										variant="gray-primary"
										block
										onClick={(event) => {
											event.stopPropagation();
											event.preventDefault();
											if (info?.link) {
												window.open(info.link, '_blank');
											}
										}}
									/>
								</BoxSection>
							</Box>
						</Link>
					);
				})
			)}
		</div>
	);
};
